










































import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Business, BusinessList } from "@/modules/businesses/types";

const BusinessNamespace = namespace("business");

@Component({})
export default class Sidebar extends Vue {
  @BusinessNamespace.Getter("getAllBusinesses") allBusinesses: BusinessList;
  @BusinessNamespace.Getter("getSelectedBusiness") selectedBusiness: Business;
  @BusinessNamespace.Action("fetchCurrentBusiness")
  fetchCurrentBusiness!: (businessId: string) => Promise<{}>;

  async chooseBusiness(businessId: string) {
    await this.fetchCurrentBusiness(businessId).catch((err) => {
      console.log(err.message);
    });
    this.$router.push({
      name: "business",
      params: { businessId: businessId },
    });
  }
}
